import { servidor } from "../servidor";
 
const getBlockedHours = async (platform, store, startOfDay, endOfDay) => {
  try {
    // Realiza la consulta a la API 
    const response = await servidor.get("/schedules/getBlockedHours", {
        params: { platform, store, startOfDay, endOfDay },
    });
    // Mapea los datos y agrega un ID a cada elemento
    return response.data.schedules
  } catch (error) {
    // console.error(error.response.message)
    // Mejora: Proporciona mensajes de error más descriptivos
    if (error.response) {
      // La solicitud se hizo, pero el servidor respondió con un código de error
      throw new Error(
        `Error en la solicitud: ${error.response.status} - ${error.response.message}`
      );
    } else if (error.request) {
      // La solicitud se hizo, pero no se recibió respuesta del servidor
      throw new Error(
        "No se recibió respuesta del servidor. Verifica tu conexión a Internet y vuelve a intentarlo."
      );
    } else {
      // Otros errores (por ejemplo, error de JavaScript)
      throw new Error(`Error desconocido: ${error.message}`);
    }
  }
};

export default getBlockedHours;
